module.exports = new __parcel__URL__("74341_h.b04211cb.jpg").toString();